"use strict";

exports.__esModule = true;
exports.DeviceDataItemSelector = DeviceDataItemSelector;
var _react = _interopRequireDefault(require("react"));
var _Selector = require("../../Core/Selector");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.category + "." + input.type + "." + input.name;
}
function renderItemText(input) {
  return input.name;
}
function renderItemLabel(input) {
  return input.units;
}
function itemPredicate(query, device) {
  var q = query.toLowerCase();
  return device.name != null && device.name.toLowerCase().indexOf(q) !== -1 || device.type != null && device.type.toLowerCase().indexOf(q) !== -1 || device.sub_type != null && device.sub_type.toLowerCase().indexOf(q) !== -1;
}

/**
 * Allows a user to select device data item(s) from a list.
 */
function DeviceDataItemSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    var placeholder = props.placeholder;
    if (!placeholder) {
      placeholder = props.multiple ? translate("DeviceDataItemSelector.placeholder.multiple", "Select Data Items") : translate("DeviceDataItemSelector.placeholder.single", "Select Data Item");
    }
    return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
      placeholder: placeholder,
      getKey: getKey,
      renderItemText: renderItemText,
      renderItemLabel: renderItemLabel,
      itemPredicate: itemPredicate,
      width: 275
    }, props));
  });
}